import { Component, OnInit } from '@angular/core';
import { LoadingService } from '@serpro/ngx-suite-rfb';
import { Ambiente } from 'src/app/shared/model/ambiente.model';
import { AmbienteService } from 'src/app/shared/services/ambiente.service';
import { BancoRecursos } from 'src/app/shared/util/banco-recursos.util';

@Component({
    selector: 'app-gerir-recursos',
    templateUrl: './gerir-recursos.component.html',
    styleUrls: ['./gerir-recursos.component.css', '../../../../../src/app/shared/css/contraste.css']
})
export class GerirRecursosComponent implements OnInit {

    bancoRecursos: BancoRecursos;

    constructor(
        private readonly loadingService: LoadingService,
        private readonly ambienteService: AmbienteService,
    ) { }

    ngOnInit(): void {
        document.title = 'Gerir banco de LUDs';
        this.loadingService.show();
        this.ambienteService.getAmbiente().subscribe({
            next: (ambiente: Ambiente) => {
                this.bancoRecursos = new BancoRecursos(ambiente);
                this.loadingService.hide();
            },
            error: () => {
                this.loadingService.hide();
            }
        });
    }
}
